export default __webpack_public_path__ + "static/media/RafiYungman.188feab8.jpg";